import React, { Component } from "react";
import CustomIcons from "../../../components/icons/kIcons.component";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import { user_career_list } from "../../user/user.api";
import "./tenders.css";
import { useEffect } from "react";
import { useState } from "react";
import BreadCrumpBack from "../../../components/navigator/back";

function Careers(props) {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    user_career_list().then((res) => {
      setData(res?.data || []);
      setCurrentPage(1);
    });
  }, []);

  const totalItems = data.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const handleLink = (linkurl) => {
    let urlLower = linkurl.toLowerCase();
    let urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };
  return (
    <>
      <div className="container-fluid event-bg">
        <div className="row m-55">
          <h3>{props.state.language === "ma" ? "തൊഴിൽ അവസരങ്ങൾ" : "Careers"}</h3>
        </div>
      </div>
      <BreadCrumpBack />
      <div className="container-fluid">
        <div className="table-container overflow-auto">
          <table className="">
            {data.length > 0 ? (
              <tr className="">
                <th className="table-head">{props.state.language==="ma"?"തലക്കെട്ട്":"Title"}</th>
                <th className="table-head ">{props.state.language==="ma"?"വിവരണം":"Description"}</th>
                <th className="table-head " style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "ലിങ്ക്" : "Link"}
                </th>
                <th className="table-head " style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "ഫയൽ" : "File"}
                </th>
              </tr>
            ) : (
              <div
                className="d-flex justify-content-center"
                style={{ fontSize: "20px" }}
              >
                No Recent Postings
              </div>
            )}
            {currentItems.map((card, i) => {
              return (
                <>
                  <tr>
                    <td className="m-2 text-left">{card.title}</td>
                    <td className="m-2 text-left">
                      {card.description
                        ? ReactHtmlParser(card.description)
                        : "no description provided"}
                    </td>
                    <td className="m-2 text-left">
                      {card?.link ? (
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleLink(card.link);
                          }}
                          className="break_link"
                        >
                          {props.state.language === "ma" ? "കാണുക" : "Open"}
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="m-2 text-left">
                      {card?.file && (
                        <span className="">
                          &nbsp;
                          <a
                            onClick={(e) => window.open(card?.file, "_blank")}
                            className="break_link"
                          >
                            {props.state.language === "ma" ? "ഡൗൺലോഡ്" : "Download"}
                          </a>
                        </span>
                      )}
                    </td>
                  </tr>
                </>
              );
            })}
          </table>
        </div>

        {totalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center mt-4 px-4 w-100 flex-wrap pagination-container" style={{ gap: '15px', paddingBottom: '30px' }}>
            <div className="text-muted" style={{ fontSize: "14px" }}>
              {props.state.language === "ma" ? (
                <>കാണിക്കുന്നത് <b>{indexOfFirstItem + 1}</b> - <b>{Math.min(indexOfLastItem, totalItems)}</b> (ആകെ <b>{totalItems}</b> കരിയർ പോസ്റ്റിംഗുകൾ)</>
              ) : (
                <>Showing <b>{indexOfFirstItem + 1}</b> - <b>{Math.min(indexOfLastItem, totalItems)}</b> of <b>{totalItems}</b> Career Postings</>
              )}
            </div>
            <div className="d-flex gap-2 align-items-center">
              <button
                className="btn btn-outline-primary btn-sm px-3 py-2"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
                style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
              >
                <i className="fa fa-chevron-left mr-1"></i> {props.state.language === "ma" ? "മുമ്പത്തെ" : "Prev"}
              </button>
              
              {(() => {
                const pages = [];
                const maxVisible = 5;
                let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                let end = Math.min(totalPages, start + maxVisible - 1);
                if (end - start + 1 < maxVisible) {
                  start = Math.max(1, end - maxVisible + 1);
                }
                
                if (start > 1) {
                  pages.push(
                    <button
                      key={1}
                      className={`btn btn-sm px-3 py-2 ${currentPage === 1 ? "btn-primary text-white" : "btn-outline-primary"}`}
                      onClick={() => setCurrentPage(1)}
                      style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                    >
                      1
                    </button>
                  );
                  if (start > 2) {
                    pages.push(<span key="dots-start" className="px-2 align-self-center text-muted">...</span>);
                  }
                }
                
                for (let i = start; i <= end; i++) {
                  pages.push(
                    <button
                      key={i}
                      className={`btn btn-sm px-3 py-2 ${currentPage === i ? "btn-primary text-white" : "btn-outline-primary"}`}
                      onClick={() => setCurrentPage(i)}
                      style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                    >
                      {i}
                    </button>
                  );
                }
                
                if (end < totalPages) {
                  if (end < totalPages - 1) {
                    pages.push(<span key="dots-end" className="px-2 align-self-center text-muted">...</span>);
                  }
                  pages.push(
                    <button
                      key={totalPages}
                      className={`btn btn-sm px-3 py-2 ${currentPage === totalPages ? "btn-primary text-white" : "btn-outline-primary"}`}
                      onClick={() => setCurrentPage(totalPages)}
                      style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                    >
                      {totalPages}
                    </button>
                  );
                }
                return pages;
              })()}

              <button
                className="btn btn-outline-primary btn-sm px-3 py-2"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
                style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
              >
                {props.state.language === "ma" ? "അടുത്തത്" : "Next"} <i className="fa fa-chevron-right ml-1"></i>
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default Careers;
